import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Phone, ArrowRight, ChevronRight } from "lucide-react";
import { COMPANY } from "../../data/site";
import { MaskLines } from "./Motion";

export const PageHero = ({ hero, breadcrumb = [] }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  return (
    <section ref={ref} className="relative pt-28 md:pt-32 px-3 md:px-6" data-testid="page-hero">
      <div className="relative overflow-hidden rounded-[32px] bg-forest text-cream grain min-h-[78vh] md:min-h-[70vh] flex items-end">
        <motion.img style={{ y }} src={hero.image} alt={hero.alt || ""} fetchpriority="high" className="absolute inset-0 w-full h-[118%] -top-[9%] object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest via-forest/60 to-forest/10" />
        <div className="relative z-[2] w-full max-w-[1400px] mx-auto px-6 lg:px-12 pb-12 md:pb-16 pt-24">
          <nav aria-label="Fil d'Ariane" className="flex flex-wrap items-center gap-1 text-xs text-cream/70 mb-8" data-testid="breadcrumb">
            <Link to="/" className="hover:text-lime">Accueil</Link>
            {breadcrumb.map(b => <span key={b.path} className="inline-flex items-center gap-1"><ChevronRight className="w-3 h-3" /><Link to={b.path} className="hover:text-lime">{b.name}</Link></span>)}
          </nav>
          <p className="eyebrow text-lime">{hero.eyebrow}</p>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-7xl font-extrabold leading-[0.95] max-w-5xl" data-testid="page-title">
            <MaskLines lines={hero.lines} />
          </h1>
          <div className="mt-8 grid lg:grid-cols-[1.3fr_1fr] gap-8 items-end">
            <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.8 }} className="lead-text text-cream/85 max-w-2xl">{hero.intro}</motion.p>
            <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75, duration: 0.8 }} className="flex flex-wrap gap-3 lg:justify-end">
              <Link to="/contact" className="btn btn-lime" data-testid="hero-quote-btn">Devis gratuit<ArrowRight className="w-4 h-4" /></Link>
              <a href={COMPANY.phoneHref} className="btn btn-ghost-light" data-testid="hero-call-btn"><Phone className="w-4 h-4" />{COMPANY.phone}</a>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
